import PermissionBlocker from "./PermissionBlocker";

export default PermissionBlocker;
